module.exports = __webpack_public_path__ + "img/mouth close.090cb6ed.png";